/**
 * Client ID of type WEB, shared by every Google sign-in call site.
 *
 * This is load-bearing for correctness, not just configuration: Google mints
 * the ID token with this value as its `aud`, and the backend verifies `aud`
 * against `SocialApp.client_id` (allauth `_verify_and_decode`). A copy that
 * drifts does not fail loudly — it produces a 400 "sign in again" that no
 * test catches.
 *
 * It lives in core rather than in either app because three call sites carried
 * their own literal: mobile's googleSignInConfig.ts, the webapp's
 * GoogleOAuthProvider, and the webapp's settings "connect Google" (#81).
 * `GoogleAuth.test.ts` fails if a fourth ever appears.
 *
 * Only the constant is shared. The two platforms still configure Google
 * differently — mobile through `GoogleSignin.configure`, the webapp through
 * `@react-oauth/google`'s auth-code flow until it moves to GIS credentials
 * (#78) — so there is no shared `configure()` to extract.
 */
export const GOOGLE_WEB_CLIENT_ID =
  '1056414418136-f918hjslogb65gljm868hd7igjg1kp52.apps.googleusercontent.com';
